import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { LightProgramBundleInfoDtoSchema } from "@modules/programBundle/api/programBundleDto"
import { LightProgramInfoDtoSchema } from "@modules/programs/gateway/programDto"
import { z } from "zod"

export enum PromoCodeStatus {
  DELETED = "DELETED",
  MAX_ATTENDEES = "MAX_ATTENDEES",
  EXPIRED = "EXPIRED",
  SCHEDULED = "SCHEDULED",
}

export const LightPromoCodeDtoSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    code: z.string(),
    type: z.enum(CouponType),
    value: z.number(),
    createdAt: z.iso.datetime(),
    duration: z.number().nullable(), // TODO wait back for refacto to durationInMonths
  })
  .meta({ id: "LightPromoCodeDtoSchema" })

export const CoachPromoCodeDtoSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    code: z.string(),
    type: z.enum(CouponType),
    value: z.number(),
    createdAt: z.iso.datetime(),
    startAt: z.iso.datetime().nullable(),
    expirationDate: z.iso.datetime().nullable(),
    durationInMonths: z.number().nullable(),
    maxAttendees: z.number().nullable(),
    onlyNewCustomer: z.boolean(),
    archived: z.boolean(),
    archivedStatus: z.enum(PromoCodeStatus).nullable(),
    programs: z.array(z.lazy(() => LightProgramInfoDtoSchema)),
    programBundles: z.array(z.lazy(() => LightProgramBundleInfoDtoSchema)),
  })
  .meta({ id: "CoachPromoCodeDtoSchema" })

export type CoachPromoCodeDto = z.infer<typeof CoachPromoCodeDtoSchema>
export type LightPromoCodeDto = z.infer<typeof LightPromoCodeDtoSchema>
